import React, { Component } from 'react';
import { RootState } from '../../../redux/store';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import { VelocityVariableState } from '../../../redux/reducers/VelocityVariableReducer';
import { AccessBase } from '../../../domain/access/BaseAccess';
import { changeVelocityVariable } from '../../../redux/actions/VelocityVariableActions';
import AccessContainer from '../../access/AccessContainer';
import RoleHelper from '../../../RoleHelper';

class VelocityVariableAccessComponent extends Component<Props> {
  render() {
    const {
      velocityVariable: { velocityVariable },
    } = this.props;
    const access: AccessBase = { permission: velocityVariable.permission, collaborators: velocityVariable.collaborators };
    return <AccessContainer changeAccess={this.changeAccess} disabled={!RoleHelper.canManage('EnrichmentVelocity')} access={access} />;
  }

  public changeAccess = (access: AccessBase) => {
    const {
      velocityVariable: { velocityVariable },
      changeVelocityVariable,
    } = this.props;
    velocityVariable.permission = access.permission;
    velocityVariable.collaborators = access.collaborators;
    changeVelocityVariable(velocityVariable);
  };
}

interface Props extends ReduxType {}

const mapStateToProps = (state: RootState) => ({
  velocityVariable: state.velocityVariable as VelocityVariableState,
});

const mapDispatchToProps = { changeVelocityVariable: changeVelocityVariable };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxType = ConnectedProps<typeof connector>;
export default connector(VelocityVariableAccessComponent);
